export default __webpack_public_path__ + "static/media/writing-competition-logo.79d31aeb.png";